/* eslint-disable quotes */
import React from "react";
import { connect } from "react-redux";
import { IconInfoCircle } from "@tabler/icons-react";

const NOTICE = {
    sq: {
        title: "Vërejtje!",
        body: "Të dhënat e publikuara në këtë platformë ofrohen vetëm për qëllime informuese. Ndalohet mbledhja automatike e të dhënave, kopjimi, shkarkimi, ruajtja, përpunimi ose ripërdorimi i tyre, tërësisht apo pjesërisht. Çdo përdorim i paautorizuar mund të rezultojë në kufizimin e qasjes dhe ndërmarrjen e masave ligjore.",
    },
    en: {
        title: "Notice",
        body: "The data published on this platform is provided for informational purposes only. The automated collection of data, copying, downloading, storing, processing, or reuse of the data, in whole or in part, is prohibited. Any unauthorized use may result in restricted access and legal action.",
    },
    sr: {
        title: "Obaveštenje",
        body: "Podaci objavljeni na ovoj platformi dostupni su isključivo u informativne svrhe. Zabranjeno je automatsko prikupljanje podataka, kopiranje, preuzimanje, čuvanje, obrada ili ponovno korišćenje podataka, u celosti ili delimično. Svaka neovlašćena upotreba može dovesti do ograničenja pristupa i pokretanja pravnih postupaka.",
    },
};

function DataNotice({ locale }) {
    const t = NOTICE[locale] || NOTICE.sq;
    return (
        <div role="note" className="tw-font-inter tw-mt-6 tw-mb-4 tw-px-3 md:tw-mt-12 md:tw-mb-5 md:tw-px-notice-x">
            <div
                className="tw-flex tw-items-start tw-gap-3 tw-px-5 tw-py-4 tw-rounded-brand tw-border tw-border-solid"
                style={{ borderColor: "#FFB300", backgroundColor: "#FFF8E1", color: "#7A4F01" }}
            >
                <IconInfoCircle
                    size={22}
                    className="tw-flex-shrink-0"
                    style={{ color: "#FFB300", marginTop: 1 }}
                    aria-hidden
                />
                <div>
                    <div className="tw-font-bold tw-text-sm tw-mb-1">{t.title}</div>
                    <p className="tw-m-0 tw-text-sm tw-leading-relaxed">{t.body}</p>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(DataNotice);
